import { styled } from 'styled-components';
import { colors, Size } from '../../abstracts';
import { Text } from '../Text';
export const Container = styled.div.withConfig({
  componentId: "aui__sc-yuss4e-0"
})(["background-color:", ";display:flex;flex-direction:column;gap:1rem;max-width:", "px;"], colors.white, Size.XXL);
export const Heading = styled(Text).attrs({
  size: 3,
  weight: 'feather',
  forwardedAs: 'h2'
}).withConfig({
  componentId: "aui__sc-yuss4e-1"
})([""]);